export default "__VITE_PUBLIC_ASSET__88ab6d97__"